import { Api } from "../../common/lib/httpRequest";
import {
  LoginRequest,
  GetUserInfoResponse
} from "../utils/types";

export const apiLogin = (data: LoginRequest): Promise<GetUserInfoResponse> => {
  return Api.post(`api/v1/staff/account/login`, data);
};